import {
    EuiBadge,
    EuiButton,
    EuiEmptyPrompt,
    EuiInMemoryTable,
    EuiNotificationBadge,
    EuiPanel,
    EuiSpacer, EuiText,
    EuiTitle, formatDate
} from "@elastic/eui";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Store} from "../../../app/stores/store-root";
import "@elastic/eui/dist/eui_theme_light.css";
import {Order} from "../../../app/models/order";
import {NavLink} from "react-router-dom";
import {SearchFilterConfig} from "@elastic/eui/src/components/search_bar/search_filters";
import * as _ from "lodash";
import {EuiSearchBarProps} from "@elastic/eui/src/components/search_bar/search_bar";
import ModalOrderApproved from "./modal-order-approved";
import MessageModal from "../../../app/common/message-modal";

type dataProps = {
    items: Order[];
};
export const AdminsOrdersList = ({items}: dataProps) => {
    const [error, setError] = useState(undefined);
    const [selection, setSelection] = useState([]);
    const [popOverOpen, setPopOverOpen] = useState(false);
    const store = useContext(Store);
    const selectionValue = {
        selectable: (order: any) => true,
        initialSelected: selection,
        onSelectionChange: (selection: any) => {
            setSelection(selection);
            console.log(selection);
        },
    };

    const [branches, setBranches] = useState<any[]>([]);
    const [agents, setAgents] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        store.Lookups.loadLookups().then(() => {
            const transformed = store.Lookups.branchRegistry.map((item) => {
                return {"value": item.value, "name": item.label}
            });
            setBranches(transformed);
        });
        store.Orders.PendingApprovalOrders.loadItems().then(() => {
            const transformed = _.uniqBy(store.Orders.PendingApprovalOrders.Orders.map((item: Order) => {
                return {'value': item.CreatedByName, 'name': item.CreatedByName}
            }), (item) => item.value);
            setAgents(transformed);
        });
    }, [store.Lookups, store.Orders.PendingApprovalOrders])


    const searchFilters: SearchFilterConfig[] = [

        {
            type: 'field_value_selection',
            field: 'DeliveryOffice',
            name: 'Branch',
            multiSelect: false,
            options: branches
        },
        {
            type: 'field_value_selection',
            field: 'CreatedByName',
            name: 'Sending Agent',
            multiSelect: false,
            options: agents
        },
    ]
    const [message, setMessage] = useState(
        <EuiEmptyPrompt
            iconType="editorStrike"
            title={<h2>No orders that is pending on administrator approval</h2>}
            body={
                <Fragment>

                </Fragment>
            }
            actions={
                <EuiButton color="primary" fill>
                    Load orders
                </EuiButton>
            }
        />
    );


    const approveOrder = (order: Order) => {
        setLoading(true);
        order.ApprovedAt=new Date();
        order.ApprovedByName = `${store.Users.Name} ${store.Users.FamilyName}`;
        order.ApprovedByUserName = store.Users.UserName;
        order.ApprovedBySub = store.Users.Sub;

        store.Orders.ApproveOrder(order).then(() => {
            store.Modal.closeModal();
            const message = `Order ${order.Reference} have been approved.`
            store.Modal.openModal(<MessageModal message={message} success={true}/>);
        }).finally(() => {
            setLoading(false)
        })
    }

    const rejectOrder = (order: Order) => {
        setLoading(true);
        store.Orders.RejectOrder(order).then(() => {
            const message = `Order ${order.Reference} have been rejected.`
            store.Modal.openModal(<MessageModal message={message} success={true}/>);
        }).finally(() => {
            setLoading(false)
        })
    }


    const actions: any[] = [
        {
            name: 'Approve',
            description: 'Approve this order',
            icon: 'check',
            type: 'icon',
            onClick: approveOrder,
        },
        {
            name: 'Reject',
            description: 'Reject this order',
            icon: 'cross',
            type: 'icon',
            onClick: rejectOrder,
        },
    ]

    const renderToolsRight = () => {
        return [
            <EuiButton
                key="loadUsers"
                size="s" fill
                isDisabled={submitting || !selection || selection.length === 0}
                isLoading={submitting}
                onClick={() => {
                    onApproveSelected();
                }}
            >
                Approve
            </EuiButton>,
            <EuiButton
                key="loadUsersError"
                isDisabled={submitting || !selection || selection.length === 0}
                isLoading={submitting}
                size="s"
                onClick={() => {
                    onRejectSelected()
                }}
            >
                Reject
            </EuiButton>,
        ];
    };


    const searchSettings: EuiSearchBarProps = {
        toolsLeft: renderToolsRight(),
        box: {
            incremental: true,
            schema: true,
            placeholder: ''
        },
        filters: searchFilters
    }


    const pendingOrdersListFields = [
        {
            field: 'Reference',
            name: 'Reference',
            sortable: true,
            truncateText: true,
            render: (reference: string) => {
                return (<NavLink to={`orders/edit/${reference}`}>
                    {reference}
                </NavLink>)
            }
        },
        {
            field: 'SendingAmount',
            name: 'Sending Amount',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.SendingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ReceivingAmount',
            name: 'Receiving',
            truncateText: true,
            render: (value: any, item: Order) => {
                return `${item.ReceivingCurrencySymbol} ${value}`
            }

        },
        {
            field: 'ExchangeRate',
            name: 'Rate',
            truncateText: true,
        },
        {
            field: 'CreatedByName',
            name: 'Created By',
            truncateText: true,
        },
        {
            field: 'DeliveryType',
            name: 'Trasnfer Type',
            truncateText: true,
            render: (type: string) => {
                if (type === '0')
                    return <EuiBadge color="#FFA500">Bank Transfer</EuiBadge>

                return <EuiBadge color="#BADA55">Cash</EuiBadge>
            }
        },
        {
            field: 'DeliveryOffice',
            name: 'Branch',
            truncateText: true,


        }
        ,
        {
            field: 'RemitterName',
            name: 'Remitter',
            truncateText: true,

        },
        {
            field: 'BeneficiaryName',
            name: 'Beneficiary',
            truncateText: true,

        },
        {
            field: 'CreatedAt',
            name: 'Created At',
            sortable: true,
            render: (date: any) => formatDate(date, "dobLong"),

        }
        ,
        {
            name: 'Actions',
            actions,
        }
    ]

    const onApproveSelected = () => {
        selection.forEach((item : Order) => {
            setSubmitting(true);

            store.Orders.ApproveOrder(item).then(() => {
                console.log(`Order Approved : ${item.Reference}`)
            }).catch((error) => {
                const {data} = error.response;
                console.log(`Error approving ${item.Reference}. Error message : ${data.error}`)
            }).finally(() => {
                setSubmitting(false);
            });
        })
    }

    const onRejectSelected = () => {
        selection.forEach((item : Order) => {
            setSubmitting(true);

            store.Orders.RejectOrder(item).then(() => {
                console.log(`Order Approved : ${item.Reference}`)
            }).catch((error) => {
                const {data} = error.response;
                console.log(`Error approving ${item.Reference}. Error message : ${data.error}`)
            }).finally(() => {
                setSubmitting(false);
            });
        })
    }


    return (
        <Fragment>

            <EuiPanel hasShadow={true} paddingSize={'l'}>
                <EuiText>
                    <h3>Orders Awiating Authorization</h3>
                    <p>
                        Below are transfer orders placed by sending Agents waiting to be approved by a Business Administrator. Administrators can either approve\reject orders one by one or in bulk. Also records can be searched , sorted and filtered </p>
                </EuiText>
                <EuiSpacer size={"xxl"}/>
                <EuiInMemoryTable
                    items={items}
                    itemId="Reference"
                    columns={pendingOrdersListFields}
                    pagination={true}
                    selection={selectionValue}
                    isSelectable={true}
                    search={searchSettings}
                    hasActions={true}
                    sorting={true}
                    message={message}
                    loading={loading}
                />
            </EuiPanel>
        </Fragment>

    );
};

//export default observer(AdminsOrdersList);
